import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { cardPad } from '../../lib/ui';

export default function Doa() {
  const { state, set, openEsign, L } = useApp();

  const doaMatrix = [
    { level: 'Procurement Officer', range: '$0 – $100,000', method: '3 Quotes' },
    { level: 'Procurement Director', range: '$100,001 – $1,000,000', method: 'e-Bidding' },
    { level: 'Executive Committee', range: '> $1,000,000 · no limit', method: 'e-Tender + Committee' },
  ];

  const doaPending = [
    { id: 'PO-2026-0048', doa: 'Procurement Director', desc: 'Tire & Wheel Replacement — Q3 Fleet Program', meta: 'GeoTrack Solutions · Issued 2026-06-22 · Requested by Sam K.', value: '$780,000' },
    { id: 'PO-2026-0047', doa: 'Executive Committee', desc: 'Property All-Risk Insurance', meta: 'Apex Insurance Co. · Issued 2026-06-21 · Requested by Maria B.', value: '$5,400,000' },
    { id: 'PO-2026-0046', doa: 'Procurement Officer', desc: 'Office Equipment Insurance Renewal', meta: 'Summit Insurance Ltd. · Issued 2026-06-20 · Requested by Paula W.', value: '$95,000' },
  ].filter((p) => !state.doaDecisions.some((d) => d.id === p.id));

  return (
    <>
      {!state.doaHintSeen && (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 16px', background: 'var(--color-warning-bg)', border: '1px solid var(--color-warning)', borderRadius: 'var(--radius-md)', marginBottom: 14, fontSize: 13, color: 'var(--color-fg-1)' }}>
          <Icon name="alert-triangle" style={{ color: 'var(--color-warning)', flex: 'none', marginTop: 1 }} />
          <div style={{ flex: 1 }}>{L('Signing here is legally binding. Check the DOA level matches the PO value before you approve — the matrix below is the rule.', 'การลงนามที่นี่มีผลผูกพันทางกฎหมาย ตรวจสอบว่าระดับ DOA ตรงกับมูลค่า PO ก่อนที่คุณจะอนุมัติ — เมทริกซ์ด้านล่างคือกฎ')}</div>
          <button onClick={() => set({ doaHintSeen: true })} style={{ fontWeight: 600, color: 'var(--color-fg-1)', whiteSpace: 'nowrap' }}>{L('Got it', 'รับทราบ')}</button>
        </div>
      )}

      <div style={cardPad(0, 'auto')}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Delegation of Authority Matrix', 'เมทริกซ์การมอบอำนาจ')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Authority Level', 'ระดับอำนาจ')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Value Range (USD)', 'ช่วงมูลค่า (ดอลลาร์)')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Method', 'วิธีการ')}</th>
            </tr>
          </thead>
          <tbody>
            {doaMatrix.map((d) => (
              <tr key={d.level} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '11px 16px', fontWeight: 600 }}>{d.level}</td>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{d.range}</td>
                <td style={{ padding: '11px 16px', color: 'var(--color-fg-2)' }}>{d.method}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: 16, alignItems: 'start' }}>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Pending Approvals (3)', 'รออนุมัติ (3)')}</div>
          {doaPending.map((p) => (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 0', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 3 }}>
                  <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700 }}>{p.id}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{p.doa}</span>
                </div>
                <div style={{ fontSize: 13 }}>{p.desc}</div>
                <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{p.meta}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 15, fontWeight: 700, fontFamily: 'var(--font-mono)', marginBottom: 8 }}>{p.value}</div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => openEsign(p.id)} className="hv-primary" style={{ padding: '7px 12px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-sm)', fontSize: 12, fontWeight: 600 }}>{L('Approve & Sign', 'อนุมัติและลงนาม')}</button>
                  <button className="hv-error" style={{ padding: '7px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 12, fontWeight: 600, background: 'var(--color-white)', color: 'var(--color-error)' }}>{L('Reject', 'ปฏิเสธ')}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Decisions This Session', 'การตัดสินใจในเซสชันนี้')}</div>
          {state.doaDecisions.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '24px 0', color: 'var(--color-fg-3)', fontSize: 13 }}>{L('No decisions yet this session.', 'ยังไม่มีการตัดสินใจในเซสชันนี้')}</div>
          ) : (
            state.doaDecisions.map((d, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, padding: '11px 0', borderBottom: '1px solid var(--color-border)' }}>
                <Icon name="check" style={{ color: 'var(--color-success)', flex: 'none', marginTop: 2 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-mono)' }}>{d.id} {L('approved', 'อนุมัติแล้ว')}</div>
                  <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{L('Signed via e-Sign Cloud · Envelope', 'ลงนามผ่าน e-Sign Cloud · ซองเอกสาร')} {d.envelope} · {d.time}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
